import BCButom from "../../Tools/BCButom";

const ContactUs = () => {
    return (
            <div className="contactUs">
                <div className="cardContactUs">
                    <div className="header">
                        <h4 style={{}}> کلینیک تهران :     </h4>
                        <div className="d-inline-block contactUsItemList" style={{}}>
                            <ul className="mt-4">
                                <li> خیابان پاسداران، پاسداران ۳/۱، پلاک ۲۴</li>
                                <li>۰۵۱-۳۲۲۳۸۷۰۸-۹</li>
                                <li>info@modaghegh.com</li>
                            </ul>
                        </div>
                        <div className="contactUsBtnReservation" style={{marginTop: "20px"}}>
                            <a href="https://app.minns.cloud/reservations/reserve/1?_token=5NjJVk7oSsGRKvffJTxGWhS8EjSKhQ5erfQoDaop&selected_location=1&account_id=1&payment_type=&reservation_time_id=" target={`_blank`}><BCButom className="w-50 btnOne text-center">رزرو نوبت » </BCButom></a>
                        </div>
                    </div>
                </div>
                <div className="cardContactUs">
                <div className="header">    
                        <h4 style={{}}>کلینیک مشهد : </h4>
                        <div className="d-inline-block contactUsItemList" style={{}}>
                            <ul className="mt-2">
                                <li>  شنبه:   هماهنگی با آقای رضانژاد ۰۹۳۳۳۱۹۱۳۶۳ - ۱۴:۰۰ - ۱۶:۰۰</li>
                                <li>یکشنبه : یکشنبه بیمارستان ولایت - ۱۰:۰۰ - ۱۲:۰۰</li>
                                <li>دوشنبه : دوشنبه - ۱۷:۰۰ - ۲۰:۰۰</li>
                                <li>سه شنبه : سه شنبه بیمارستان مادر - ۱۷:۰۰ - ۱۸:۰۰</li>
                                <li>چهار شنبه : چهارشنبه - ۱۷:۰۰ - ۲۰:۰۰</li>
                            </ul>
                        </div>
                        <div className="contactUsBtnReservation" style={{marginBottom: "-10px"}}>
                            <a href="https://app.minns.cloud/reservations/reserve/1?_token=5NjJVk7oSsGRKvffJTxGWhS8EjSKhQ5erfQoDaop&selected_location=6&account_id=1&payment_type=&reservation_time_id=" target={`_blank`}><BCButom className="w-50 btnOne text-center">رزرو نوبت » </BCButom></a>
                        </div>
                    </div>
                </div>

            </div>
    )   

}
export default ContactUs;